/* template */
<template minapp="mpx" xlang="wxml"><div class="content-table"><table class="main-table"><tbody><tr><th :style="[({width: '70px'})] | transRpxStyle"></th><th :style="[({width: '130px'})] | transRpxStyle">改签距发车时间</th><th>改签的列车</th><th :style="[({width: '70px'})] | transRpxStyle">改签费</th></tr><tr><td rowspan="4">开车前</td><td>48小时以上</td><td>预售内的列车</td><td rowspan="2" :style="[({color: '#FF6221'})] | transRpxStyle">免费</td></tr><tr><td>不足48小时</td><td>票面乘车日期以前(含当日)的列车</td></tr><tr><td>24小时-48小时(不含)</td><td rowspan="2">票面乘车日期次日及以后的列车</td><td :style="[({color: '#FF6221'})] | transRpxStyle">5%</td></tr><tr><td><24小时</td><td :style="[({color: '#FF6221'})] | transRpxStyle">15%</td></tr><tr><td rowspan="2">开车后</td><td rowspan="2">在当日24点之前</td><td>票面乘车日期当日其他的列车</td><td :style="[({color: '#FF6221'})] | transRpxStyle">免费</td></tr><tr><td>票面乘车日期次日及以后的列车</td><td :style="[({color: '#FF6221'})] | transRpxStyle">40%</td></tr></tbody></table><div class="prompt">改签费按改签前后较低票价车票的票面价格计算。</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m2d04b976"}'>
  .content-table
    position relative
    opacity 1
    display flex
    flex-direction column
    padding-bottom 12px
    box-sizing border-box
    background #FFFFFF
    z-index 0
    .main-table
      margin 12px 12px 0
      border-radius 4px
      border-collapse collapse
      margin-bottom 12px
      border-radius 4px
      overflow hidden
      th, td
        border 1px solid #e5e5e5
        padding 8px 12px
        box-sizing border-box
        color #666
        font-size 14px
      th
        text-align left
        padding 8px 12px
        background rgba(231, 241, 255, 0.3)
        box-sizing border-box
        border-color rgba(0, 0, 0, 0.08)
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
      td
        box-sizing border-box
        padding 12px
        background #fff
        // vertical-align middle
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
        z-index 1
        .label
          display flex
          margin-bottom 8px
          &:last-child
            margin 0
        .label-text
          width 70px
          float left
          flex-shrink 0
          white-space nowrap
    .prompt
      margin 0 12px
      box-sizing border-box
      padding 8px 10px
      background #FFF4EE
      color #FF7D41
      border-radius 8px
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      line-height 18px
      letter-spacing 0px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2d04b976"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-table.mpx.js?isComponent&outputPath=components%2Fchange-table2d04b976%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-table.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchange-table2d04b976%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2d04b976"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/change-table2d04b976/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
